import { SPP } from 'chameleon-src/components/assignments/constants';
import TextWithTooltip from 'chameleon/ui-stack/ui/assessments/text-with-tooltip';
import RetiredItemIcon from 'legacy-src/utility/IconWithDescription/RetiredItemIcon';
import BulkTableCheckbox from 'legacy-src/components/TeacherOrganize/components/BulkTableCheckbox';
import QuizItemControls from 'chameleon/ui-stack/ui/tables/QuizItemControls';
import StudentSettingsData from 'chameleon/legacy/src/components/assessment/Assessments/StudentSettingsData';
import { SecureInfoIcon } from 'legacy-src/utility';
import React from 'react';
import AssignmentTypeIcon from '../assignment-type-icon';

const AssessmentName = ({
  assessment = {},
  openVideo,
  videoOpenProps,
  openPreview,
  showSharedQuizIcon,
  titleAriaLabel,
  index = 0,
  moveItem = () => {},
  isLast = false,
  showReorderActions = false,
  assignment = {},
  studentsBySection = {},
}) => {
  const {
    type,
    title: assessmentTitle,
    id: assessmentId,
    is_spp: isSPP,
  } = assessment;

  const isVideo = type === 'video';

  return (
    <div className="flex items-center font-medium cursor-pointer">
      <BulkTableCheckbox
        id={assessmentId}
        title={assessmentTitle}
        type={type}
      />
      {showReorderActions && (
        <div className="pr-3">
          <QuizItemControls moveItem={moveItem} index={index} isLast={isLast} />
        </div>
      )}
      <div
        className="flex items-center"
        onClick={(e) => {
          e.stopPropagation();
          isVideo
            ? openVideo(videoOpenProps)
            : openPreview({ assignmentType: assessment.type || '' });
        }}
      >
        {(showSharedQuizIcon && showSharedQuizIcon) || (
          <AssignmentTypeIcon type={isSPP ? SPP : assessment.type} />
        )}
        <span className="ml-4 flex-1 pr-4 text-left">
          <TextWithTooltip
            target={`${assessmentId}-title`}
            ariaLabel={titleAriaLabel}
            tooltip="Preview Resource"
            toolTipElementProps={{
              role: 'link',
              'data-drag-element': true,
            }}
            onClick={(e) => {
              e.stopPropagation();
              isVideo
                ? openVideo(videoOpenProps)
                : openPreview({ assignmentType: assessment.type || '' });
            }}
          >
            {assessmentTitle}
          </TextWithTooltip>
        </span>
        {assessment.contains_retired_questions && (
          <RetiredItemIcon isQuestion={false} />
        )}
        {assessment.contains_secure_questions &&
          !assessment.is_practice_exam && <SecureInfoIcon isQuestion={false} />}
        {assignment.student_settings?.length > 0 && (
          <StudentSettingsData
            assignment={assignment}
            studentsBySection={studentsBySection}
            isSPP={isSPP}
          />
        )}
      </div>
    </div>
  );
};

export default AssessmentName;
